module.exports = __webpack_public_path__ + "assets/img/join2021_013.c9f843e9.png";